import { render, staticRenderFns } from "./RoomDisplay.vue?vue&type=template&id=5a37a275&scoped=true&"
import script from "./RoomDisplay.vue?vue&type=script&lang=js&"
export * from "./RoomDisplay.vue?vue&type=script&lang=js&"
import style0 from "./RoomDisplay.vue?vue&type=style&index=0&id=5a37a275&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37a275",
  null
  
)

export default component.exports